<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>纠纷列表</b></p>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入" v-model="queryValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
                </el-input>
            </div>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="openDialog">上报</el-button>
            </p>
        </div>

        <el-table :data="disputesList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="placeTable"
            highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="bigName" label="刺头" min-width="9%">
            </el-table-column>

            <el-table-column prop="identityCard" label="身份证号" min-width="16%">
            </el-table-column>

            <!-- <el-table-column prop="disputesImage" label="纠纷证明" min-width="8%" align="center">
            </el-table-column> -->

            <el-table-column prop="disputesImage" label="纠纷证明" min-width="10%">
                <template slot-scope="scope">
                    <el-image :src="'https://' + imagePath + scope.row.disputesImage"
                        v-if="scope.row.disputesImage == '' ? false : true"></el-image>
                </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="15%">
            </el-table-column>

            <el-table-column prop="statusStr" label="状态" min-width="5%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="145">
                <template slot-scope="scope">

                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small"
                        v-if="scope.row.statusStr == '待审' || scope.row.statusStr == '已审'">
                        删除
                    </el-button>

                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[6, 10, 14, 18]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-dialog title="纠纷详情" :visible.sync="dlgFormVisible" width="35%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                <!-- <div style="display: flex;"> -->
                <el-row>
                    <el-col :span="16">
                        <el-form-item label="刺头" required :label-width="formLabelWidth">
                            <el-input v-model="form.bigName" autocomplete="off" style="width:220px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="21">
                        <el-form-item label="身份证号" required :label-width="formLabelWidth">
                            <el-input placeholder="请输入" v-model="form.identityCard" clearable maxlength="18" show-word-limit
                                style="display:inline-block;width:300px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- </div> -->

                <el-row>
                    <el-col :span="14">
                        <el-form-item label="纠纷证明" :label-width="formLabelWidth" prop="disputesImage">
                            <el-upload class="avatar-uploader" action="#" :http-request="uploadImg"
                                :show-file-list="false" :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">

                                <img v-if="form.disputesImage" :src="'https://' + imagePath + form.disputesImage"
                                    class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:450px"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => addDisputes('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "ReportDisputes",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),
            imagePath: this.getImagePath(),

            disputesList: [],
            dlgFormVisible: false,

            statSearch: 0,

            queryValue: '',
            form: {
                id: '',

                bigName: '',
                identityCard: '',

                imgUrl: '',
                disputesFile: null,

                status: 0,
                remark: ''
            },

            loading: false,
            formLabelWidth: '120px',

            pageIndex: 0,
            pageNum: 6,
            total: 0,
            pageCount: 0,

            rules: {
                bigName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { required: true, message: '请输入姓名', trigger: 'change' }
                ],
                identityCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { required: true, message: '请输入身份证号', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        searchOrder(query) {

            this.disputesList = []

            if (this.queryValue !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false

                    this.getAllDisputes(this.statSearch)
                }, 200)
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        uploadImg(f) {

            this.form.disputesFile = f.file
        },
        selectClick(selection, row) {

            this.$refs.placeTable.clearSelection()
            this.$refs.placeTable.toggleRowSelection(row)

            this.form.id = row.id
        },
        rowClick(row) {
            //console.log(row)
            this.$refs.placeTable.clearSelection()
            this.$refs.placeTable.toggleRowSelection(row)

            this.form.id = row.id
        },
        handleClick(row) {

            // console.log(row);
            this.form.id = row.id

            this.form.bigName = row.bigName

            this.form.imgUrl = row.imgUrl


            this.form.identityCard = row.identityCard


            this.form.status = row.status
            this.form.remark = row.remark

            this.dlgFormVisible = true
        },
        openDialog() {

            this.form.id = ''

            this.form.bigName = ''
            this.form.identityCard = ''

            this.form.remark = ''

            this.form.imgUrl = ''

            this.dlgFormVisible = true

        },
        deleteClick(row) {

            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removePlaceOrder(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addDisputes(formName) {

            this.$refs[formName].validate((valid) => {
                if (valid) {

                    const form = new FormData()

                    form.append('id', this.form.id)

                    form.append('bigName', this.form.bigName)

                    form.append('identityCard', this.form.identityCard)

                    form.append('remark', this.form.remark)
                    form.append('companyId', this.companyId)

                    form.append('creator', this.userId)

                    let arr = Object.keys(this.form.disputesFile)
                    if (arr.length == 0) {
                        // console.log('000')
                        form.append('disputesFile', new File([], 'file'))
                    } else {
                        form.append('disputesFile', this.form.disputesFile)
                    }

                    this.$axios({
                        method: "post",
                        url: "/shiro/disputes/add",
                        data: form,
                        headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message(data.msg)
                            return
                        }

                        this.dlgFormVisible = false

                        this.getAllDisputes(this.statSearch)
                    })
                } else {
                    return false
                }
            })
        },
        searchByStatus(val) {
            this.total = 0

            this.getAllDisputes(val)
        },
        removePlaceOrder(row) {
            
            this.$axios({
                method: "delete",
                url: "/shiro/place/order/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAllDisputes(this.statSearch)
            })
        },
        getAllDisputes(val) {

            this.$axios({
                method: "post",
                url: "/shiro/disputes/getAll",
                data: {
                    status: val,
                    queryParam: this.queryValue,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    creator: this.userId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.disputesList = data.data

                if (this.disputesList.length > 0) {

                    this.total = this.disputesList[0].total
                }

                for (let i in this.disputesList) {

                    if (this.disputesList[i].status == 0) {

                        this.disputesList[i].statusStr = '待审'

                    } else if (this.disputesList[i].status == 1) {

                        this.disputesList[i].statusStr = '已审'
                    }
                }

            })
        },
        pageClick(currentPage) {
            this.disputesList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAllDisputes(this.statSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllDisputes(this.statSearch)
        },
    },
    mounted() {
        console.log('reportDisputes.vue--mounted()')

        this.setDefaultPath('/reportDisputes')

        this.getAllDisputes(this.statSearch)
    }
}
</script>

<style>
.el-badge {
    position: relative;
    vertical-align: middle;
    display: inline-block;
}

.radio-sup {
    border-radius: 8px;
    color: #fff;
    display: inline-block;
    font-size: 13px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
    background-color: red;
    position: absolute;
    top: -10px;
    right: 60%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>